import Vue from 'vue'
import store from './store.js'
import App from './App.vue'
import 'es6-promise/auto'
// font-awesome icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faStar, faEyeSlash, faSpinner, faUser, faCopy, faLanguage, faPlus, faPlusCircle, faPlusSquare, faPencilAlt, faSearch, faLink, faChevronDown, faChevronRight, faCog, faArrowLeft, faUndo} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faStar, faLanguage, faEyeSlash, faSpinner, faUser, faCopy, faPlus, faPlusCircle, faPlusSquare, faPencilAlt, faSearch, faLink, faChevronDown, faChevronRight, faCog, faArrowLeft, faUndo);
Vue.component('font-awesome-icon', FontAwesomeIcon)
// copy to clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
// set/read cookies
import VueCookie from 'vue-cookie';
Vue.use(VueCookie);
// loggin
import VueLogger from 'vuejs-logger';
const isProduction = process.env.NODE_ENV === 'production';
const options = {
  isEnabled: true,
  logLevel : isProduction ? 'info' : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};
Vue.use(VueLogger, options);

import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.use(Tooltip);

// vue-tour for onboarding tutorials
import VueTour from 'vue-tour';
import 'vue-tour/dist/vue-tour.css';

Vue.use(VueTour);

Vue.config.productionTip = false;

import * as server from './Server';
import router from './router'

Vue.mixin({
  beforeCreate() {
    const options = this.$options;
    if (options.server) {
      this.$server = options.server;
    } else if (options.parent && options.parent.$server) {
      this.$server = options.parent.$server;
    }
  },
  methods: {
  }
});

console.log(process.env)

if (process.env.VUE_APP_TESTING) {
  Vue.prototype.$isTestingCypress = true;
  console.log("Running in Cypress testing mode");
}

new Vue({
  store,
  server,
  router,
  render: h => h(App)
}).$mount('#app')
